import React from "react";
import FormField from "../FormInputs/FormField";

const SelectOrganization = ({
  organizations,
  organizationalID,
  setOrganizationalID,
}) => {
  // If user belongs to only one organization, show it as read-only
  if (organizations.length === 1) {
    const org = organizations[0];
    return (
      <div className="relative mb-4">
        <label className="absolute top-[-12px] left-3 bg-white px-1 text-brand-charcoal">
          Organization
        </label>
        <input
          type="text"
          value={`${org.name}${
            org.nameAbbreviation ? ` (${org.nameAbbreviation})` : ""
          }`}
          readOnly
          className="border border-brand-charcoal/20 p-3 rounded-lg w-full bg-brand-cream text-brand-charcoal focus:outline-none cursor-not-allowed"
        />
      </div>
    );
  }

  // If user belongs to multiple organizations, show dropdown
  const options = organizations.map((org) => ({
    value: org.id,
    label: `${org.name}${
      org.nameAbbreviation ? ` (${org.nameAbbreviation})` : ""
    }`,
  }));

  return (
    <FormField
      label="Select Organization"
      value={organizationalID || ""}
      onChange={(e) => setOrganizationalID(e.target.value)}
      isSelect={true}
      options={options}
    />
  );
};

export default SelectOrganization;
